import { useState } from "react";

export type FaqItem = { q: string; a: string };

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-t border-b border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <article key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-foreground-900 group-hover:text-primary-600 transition-colors text-sm md:text-base">
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</p>
            )}
          </article>
        );
      })}
    </div>
  );
}